import React from 'react';

import {StyledGrid} from 'presentation/components';
import {GetAuthorizationsOdontoModel} from 'domain/usecases/private/authorizations-odonto/get-authorizations-odonto';
import {AuthorizationOdontoCard} from '../AuthorizationOdontoCard';
import {AuthorizationsOdontoResponseProps} from './types';

export function AuthorizationsOdonto({authorizations}: AuthorizationsOdontoResponseProps) {
	return (
		<StyledGrid.Root>
			{authorizations?.map(
				(authorization: GetAuthorizationsOdontoModel['content'][0], index: number) => (
					<StyledGrid.Item sm={12} md={12} lg={6} key={index}>
						<AuthorizationOdontoCard {...authorization} />
					</StyledGrid.Item>
				),
			)}
		</StyledGrid.Root>
	);
}
